import { render, staticRenderFns } from "./sendUpdate.vue?vue&type=template&id=2b22b22b&scoped=true&"
import script from "./sendUpdate.vue?vue&type=script&lang=js&"
export * from "./sendUpdate.vue?vue&type=script&lang=js&"
import style0 from "./sendUpdate.vue?vue&type=style&index=0&id=2b22b22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22b22b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VImg,VSnackbar,VSpacer,VToolbar})
